import { IconButton, Toolbar, Typography, AppBar, Badge, Avatar } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useStateValue } from '../../../Contexto/store';
import Idioma from '../../Idiomas/Idioma';
import DiccionarioEtiquetas from '../../../Configuracion/Idiomas/Etiquetas_Diccionario';
import { obtenerConfiguracionAppCompania } from '../../../Actions/Companias/CompaniaAction';
import { NuevasNotificacionesUsuario } from '../../../Actions/Mensajes/MensajeriaInternaAction';

import NotificationsIcon from '@mui/icons-material/Notifications';
import EventIcon from '@mui/icons-material/Event';
import MoreVert from '@mui/icons-material/MoreVert';
import HomeIco from '@mui/icons-material/Home';
import HistoryIcon from '@mui/icons-material/History';

import { styleBarMovil, styleButtonBar } from '../../Tool/Style';
import { defaultNavBarColor, defaultNavLineColor, defaultNavTextColor, defaultNavIconColor, defaultNavIconBG } from '../../Tool/PaletaColores';

import Companias from './Companias';
import PerfilUsuarioModal from './PerfilUsuarioModal';

import { ImagenesBGHeaderHome } from '../../../Configuracion/Llaves/ImgBGHomeHeader';
import IconoHeader from '../../../Activos/Imagenes/IconoHeader.svg';

import { LlavesConfiguraciones, LLavesModuloUtilidades } from '../../../Configuracion/Llaves/RepositorioConfig';


const BarSesion = ({ props }) => {

    //Estilo de la barra
    const classBarMovil = styleBarMovil();

    //Estilo de los iconos de la barra
    const classIcon = styleButtonBar();

    const logoCompania = localStorage.getItem("logoCompania_ClassLimitless");

    const [TotalNotificaciones, setTotalNotificaciones] = useState(0);

    // se importa la variable global de sesion 
    // {a,b,c} ->  respresentan los reducer que se injectan en el contexto , son variables globales para todos los componentes 
    // dispatch -> Disparador del evento de cambio
    const [{ etiquetasIdioma, sesionUsuario, compania, cargandoRed }, dispatch] = useStateValue();

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });
    }, [etiquetasIdioma]);

    const inicializerPropertiesCompany = async () => {
        dispatch({ type: "LOAD_COMP", texto: etiquetas.EtiquetasComponente.CargandoModal.Et_Cargando });
        const ComConfResp = await obtenerConfiguracionAppCompania(sesionUsuario.usuario.companyId);

        if (ComConfResp.status === 200) {
            const imgBGDesktopShow = (ComConfResp?.data["cfgImgBGDesktop"] !== "") ? ComConfResp?.data["cfgImgBGDesktop"] : "";
            const imgBGMovilShow = (ComConfResp?.data["cfgImgBGMovil"] !== "") ? ComConfResp?.data["cfgImgBGMovil"] : "";

            const temNavBarColor = (ComConfResp?.data["cfgNavBarColor"] !== "") ? ComConfResp?.data["cfgNavBarColor"] : defaultNavBarColor;
            const temNavLineColor = (ComConfResp?.data["cfgNavLineColor"] !== "") ? ComConfResp?.data["cfgNavLineColor"] : defaultNavLineColor;
            const temNavTextColor = (ComConfResp?.data["cfgNavTextColor"] !== "") ? ComConfResp?.data["cfgNavTextColor"] : defaultNavTextColor;
            const temNavIconColor = (ComConfResp?.data["cfgNavIconColor"] !== "") ? ComConfResp?.data["cfgNavIconColor"] : defaultNavIconColor;
            const temNavIconBG = (ComConfResp?.data["cfgNavIconBG"] !== "") ? ComConfResp?.data["cfgNavIconBG"] : defaultNavIconBG;

            const temLogoLimitless = (ComConfResp?.data["cfgImgBGDesktop"] !== "") ? "N" : "S";
            const temLogoLimitlessMovil = (ComConfResp?.data["cfgImgBGMovil"] !== "") ? "N" : "S";

            dispatch({
                type: "ESTABLECER_COMPANY",
                CfgConfigId: ComConfResp?.data["cfgConfigId"],
                ComCompanyId: ComConfResp?.data["cfgCompanyIdFk"],
                ComName: ComConfResp?.data["cfgCompanyName"],
                CfgNavBarColor: temNavBarColor,
                CfgNavLineColor: temNavLineColor,
                CfgNavTextColor: temNavTextColor,
                CfgNavIconColor: temNavIconColor,
                CfgNavIconBG: temNavIconBG,
                //CfgImgBGDesktop: 'url("' + imgBGDesktopShow + '")',
                //CfgImgBGMovil: 'url("' + imgBGMovilShow + '")',
                CfgImgBGDesktop: imgBGDesktopShow,
                CfgImgBGMovil: imgBGMovilShow,
                LogoLimitless: temLogoLimitless,
                LogoLimitlessMovil: temLogoLimitlessMovil
            });
        } else {

            dispatch({
                type: "ESTABLECER_COMPANY",
                CfgConfigId: '',
                ComCompanyId: '',
                ComName: etiquetas.EtiquetasComponente.AppBarLang.Et_TituloPrincipal,
                CfgNavBarColor: defaultNavBarColor,
                CfgNavLineColor: defaultNavLineColor,
                CfgNavTextColor: defaultNavTextColor,
                CfgNavIconColor: defaultNavIconColor,
                CfgNavIconBG: defaultNavIconBG,
                //CfgImgBGDesktop: 'url("' + ImagenesBGHeaderHome.ImgBGDesktop + '")',
                //CfgImgBGMovil: 'url("' + ImagenesBGHeaderHome.ImgBGMovil + '")',
                //CfgImgBGDesktop: ImagenesBGHeaderHome.ImgBGDesktop,
                //CfgImgBGMovil: ImagenesBGHeaderHome.ImgBGMovil,
                CfgImgBGDesktop: "",
                CfgImgBGMovil: "",
                LogoLimitless: 'S',
                LogoLimitlessMovil: 'S'
            });
        }
        dispatch({ type: "CLOSE_LOAD_COMP" });
    };

    useEffect(() => {
        inicializerPropertiesCompany();
    }, [sesionUsuario?.usuario.companyId]);

    useEffect(() => {
        ObtenerCantidadMensajeriaSinLeer();
    }, []);

    const ObtenerCantidadMensajeriaSinLeer = async () => {
        const objetoPeticion = {
            UserId: sesionUsuario.usuario.userId
        };

        await NuevasNotificacionesUsuario(objetoPeticion).then(response => {
            if (response.status === 200) {
                setTotalNotificaciones(response.data);
            }
        });
    };
   
    return (
        <React.Fragment>
            <AppBar position="relative" style={{
                backgroundColor: compania.CfgNavBarColor,
                height: 50,
                flexDirection: 'column',
                justifyContent: 'center',
                borderBottom: "solid " + compania.CfgNavLineColor + " 3.5px"
            }}>
                <Toolbar style={{ minHeight: 40 }}>
                    <IconButton
                        color='inherit'
                        className={classIcon.IconButton}
                        style={{ backgroundColor: compania.CfgNavIconBG, marginLeft: 0 }}
                        onClick={() => { window.location.href = LlavesConfiguraciones.urlModuloLoginHome }}
                        size="large">
                        {
                            (logoCompania === "" || logoCompania === undefined) ? 
                                <HomeIco className={classIcon.Icon} style={{ color: compania.CfgNavIconColor }} />
                                /*<img style={{ height: 46, width: 46 }} alt="IconoHeader" src={IconoHeader} />*/
                                :
                                <Avatar src={logoCompania} imgProps={{
                                    style: {
                                        objectFit: 'scale-down'
                                    }
                                }} />
                        }                        
                    </IconButton>
                    <Typography variant="h2" style={{ color: compania.CfgNavTextColor, marginLeft: 10 }}>{compania.ComName}</Typography>
                    <div className={classBarMovil.grow}>
                    </div>
                    <div className={classBarMovil.seccionDesktop}>
                        <Companias />
                        <Idioma />
                        <IconButton
                            color='inherit'
                            className={classIcon.IconButton}
                            style={{ backgroundColor: compania.CfgNavIconBG }}
                            onClick={() => { window.location.href = LLavesModuloUtilidades.rutaNotificaciones }}
                            size="large">
                            <Badge badgeContent={TotalNotificaciones} color="secondary">
                                <NotificationsIcon color='primary' className={classIcon.Icon} style={{ color: compania.CfgNavIconColor }} />
                            </Badge>
                        </IconButton>          
                        <IconButton
                            color='inherit'
                            className={classIcon.IconButton}
                            style={{ backgroundColor: compania.CfgNavIconBG }}
                            onClick={() => { window.location.href = LLavesModuloUtilidades.rutaAgenda }}
                            size="large">
                            <EventIcon className={classIcon.Icon} style={{ color: compania.CfgNavIconColor }} />
                        </IconButton>
                        <IconButton
                            color='inherit'
                            className={classIcon.IconButton}
                            style={{ backgroundColor: compania.CfgNavIconBG }}
                            onClick={() => { window.location.href = LLavesModuloUtilidades.rutaControlVersiones }}
                            size="large">
                            <HistoryIcon className={classIcon.Icon} style={{ color: compania.CfgNavIconColor }} />
                        </IconButton>
                        <PerfilUsuarioModal />
                    </div>
                    <div className={classBarMovil.seccionMobile}>
                        <IconButton color="inherit" onClick={() => { }} size="large">
                            <MoreVert fontSize="large" className={styleButtonBar.IconWhite} />
                        </IconButton>
                    </div>
                </Toolbar>
            </AppBar>
        </React.Fragment>
    );
};

export default withRouter(BarSesion);